export default __webpack_public_path__ + "locales/el-GR/EmptyView.json?hash=d90b7d48bdb8f9a07065038597dffbef";